import React, { useState } from "react";
import { Col, Container, Row, Modal } from "react-bootstrap";
import Img1 from "../../../images/landing/clutch_logo.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";
import BannerForm from "../../components/bannerfrom";
import BgImg from "../../../images/locationgcc/dxb/ae/footprint_back.webp";

const PartnerLanding = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div
      className="partner_usa_lp p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundColor: "#F8F8FB",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="partner_content">
              <h2>TekRevol's Footprint in the GCC!</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example dark_bg_text" data-text="اثار الاقدام">
              <p>
                TekRevol's influence echoes as a frontrunner in digital
                transformation within the GCC. Our inventive solutions redefine
                sectors and catalyze the transformation of businesses across the
                region.
              </p>
              <p>Discover our footprint in numbers:</p>
              <Link
                to="/contact"
                className="lp_btn"
                aria-label="TekRevol Contact"
                onClick={handleShow}
              >
                Let’s Talk
              </Link>
            </div>
          </Col>
        </Row>
        <Row className="h-100 partner_padd">
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">300+</div>
            <div className="partner-para">
              <p>Apps Developed</p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">60+</div>
            <div className="partner-para">
              <p>
                Clutch Reviews
                <Link to="https://clutch.co/profile/tekrevol#reviews" rel="nofollow">
                  <LazyLoadImage
                    src={Img1}
                    effect="blur"
                    alt="tekrevol_EBook"
                    className="img-fluid"
                  />
                </Link>
              </p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">35+</div>
            <div className="partner-para">
              <p>Industries Served </p>
            </div>
          </Col>
        </Row>
      </Container>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="landing_lp_popup"
      >
        <div className="modal_forms">
          <BannerForm setShow={setShow} />
        </div>
      </Modal>
    </div>
  );
};

export default PartnerLanding;
